//#region imports
// react
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// custom libarires
import { PartnerCarousel, BigLabelValue, AnimatedTextContainer } from '_atoms';
import { NavBarNew, Footer } from '_molecules';
import { getWebsiteMetrics } from '_services/review-service';

// bootstrap
import { Row, Col, Button } from 'react-bootstrap';

// style
import './styles.css';


// affiliation images
import prmUserMap from "_assets/images/airports/global-user-map-new.png"
// import bannerBg from "_assets/images/home/bannerbg.jpg";
import bannerBg from "_assets/images/home/bg2.jpg";
import passengerApp from "_assets/images/home/passenger-app.png";
import logo from '_assets/images/logo/blue-circle.png';

// awards images
import award1 from "_assets/images/awards/482346164_645380227865174_6826758922577828762_n.jpg"
import award2 from "_assets/images/awards/Conor-Halpin---FEA-Winner-2024.jpg"

// fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAppStoreIos, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

//#endregion

const defaultWebsiteMetrics = {
  bookings: 0,
  users: 0,
  reviews: 0,
  surveyAnswers: 0,
  airports: 0,
  airlines: 0,
};

const websiteMetricItems = [
  { key: "bookings", label: "Assistance Requests Complete" },
  { key: "airports", label: "International + Domestic Airports" },
  { key: "airlines", label: "Airlines" },
  { key: "users", label: "Passenger Mobile Downloads" },
  { key: "reviews", label: "Passenger Reviews Complete" },
  { key: "surveyAnswers", label: "Passenger Surveys Complete" },
];


const Home = () => {
  // nav
  const history = useHistory();

  //#region variables
  const verticalMargin = '150px';
  const footerMargin = '150px'
  const borderWidth = 0;

  const iOSUrl = 'https://apps.apple.com/ie/app/prm-assist/id1574371912';
  const androidUrl = 'https://play.google.com/store/apps/details?id=com.prmassist';
  //#endregion


  //#region state
  const [scrolledHome, setScrolledHome] = useState(false);
  const [websiteMetrics, setWebsiteMetrics] = useState(defaultWebsiteMetrics);

  //#endregion

  //#region side effects
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      setScrolledHome(scrollTop > 30);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    let mounted = true;

    getWebsiteMetrics()
      .then((metrics) => {
        if (mounted && metrics) {
          setWebsiteMetrics({ ...defaultWebsiteMetrics, ...metrics });
        }
      })
      .catch((error) => {
        console.error("Error loading website metrics", error);
      });

    return () => {
      mounted = false;
    };
  }, []);

  //#endregion
  return (
    <>
      {/* Background image */}
      <div
        className="bg-banner-parent"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          backgroundImage: `url(${bannerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: -2,
        }}
      />

      <div className={`${scrolledHome ? 'scrolledHome' : ''} `}>

        {/* nav bar */}
        <NavBarNew from={"home"} />

        {/* intro text */}
        <section className="hero-section d-flex px-5 align-items-center justify-content-center" >
          <div className="col-12 col-lg-8">
            <AnimatedTextContainer>
              <p className={`display-2 fw-bold ${scrolledHome ? "text-dark" : 'text-white'} mb-4`} style={{ fontFamily: "'Inter', sans-serif" }}>
                Transforming the PRM experience, built for the modern airport experience, delivered seamlessly - all in one unified system.
              </p>

              <a href="mailto:demorequest@prmassist.com?subject=Demo%20Request">
                <Button variant={`${scrolledHome ? 'outline-primary' : 'outline-light'}`} className={`mt-3 ${!scrolledHome ? 'shadow' : ''}`} style={{ width: 160, borderRadius: 50 }}>
                  Learn More
                </Button>
              </a>
            </AnimatedTextContainer>
          </div>
        </section>

        {/* World map image */}
        <section className="full-height-section p-2 p-lg-5" style={{ backgroundColor: '#F7F7F7' }}>
          <div>
            <AnimatedTextContainer>
              <Col xs={12} className="d-flex justify-content-center">
                <img
                  src={prmUserMap}
                  className="section-image"
                  alt="PRM User Map"
                />
              </Col>
            </AnimatedTextContainer>
          </div>

          {/* Statistics */}
          <Row className="mt-4 w-100 justify-content-center">
            {websiteMetricItems.map((metric) => (
              <Col key={metric.key} xs={12} sm={6} md={4} lg={4} className="mb-3 d-flex justify-content-center">
                <AnimatedTextContainer>
                  <BigLabelValue value={websiteMetrics[metric.key]} label={metric.label} animateCount={true} withPlusIcon={true} />
                </AnimatedTextContainer>
              </Col>
            ))}
          </Row>
        </section>


        {/* find your solution */}
        <section className="full-height-section p-2 p-lg-5">
          <Row className="align-items-center justify-content-center">
            {/* Left Column */}
            <Col xs={12} sm={12} md={6} lg={6} className="d-flex flex-column align-items-center justify-content-center" style={{ padding: '2.5rem' }}>
              <AnimatedTextContainer>
                <h1 style={{ fontWeight: 200, fontFamily: 'Inter' }}>Find your solution</h1>
                <div className="mt-5 d-flex flex-column justify-content-center gap-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  {/* Passenger Experience */}
                  <div>
                    <h4>Passenger Experience</h4>
                    <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>Empower passengers to book assistance in advance and pre-order airport essentials — all from our intuitive mobile app.</p>
                  </div>
                  {/* Operations Performance */}
                  <div>
                    <h4>Operations Performance</h4>
                    <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>Combine your team’s expertise with our platform to streamline workflows and boost efficiency.</p>
                  </div>
                  {/* Customer Satisfaction */}
                  <div>
                    <h4>Customer Satisfaction</h4>
                    <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>Engage passengers, gather feedback, and enhance service quality with real-time communication tools.</p>
                  </div>
                </div>
                <a href="mailto:demorequest@prmassist.com?subject=Demo%20Request">
                  <Button variant="outline-primary" className="mt-3" style={{ width: 150, borderRadius: 50, fontFamily: "'Inter', sans-serif" }}>Request a Demo</Button>
                </a>
              </AnimatedTextContainer>
            </Col>

            {/* Right Column */}
            <Col xs={12} sm={12} md={6} lg={6} className="d-flex align-items-center justify-content-center" style={{ padding: '2.5rem' }}>
              <AnimatedTextContainer>
                <img className="section-image" src={logo} style={{ width: '100%', maxHeight: 'min(600px,70vh)', borderRadius: 10 }} />
              </AnimatedTextContainer>
            </Col>
          </Row>

        </section>

        {/* download passenger app */}
        <section className='full-height-section p-2 p-lg-5'>
          <Row className="d-flex align-items-center justify-content-center">
            <Col xs={12} sm={12} md={6} lg={6} className="d-flex align-items-center justify-content-center" style={{ padding: '2.5rem' }}>
              <AnimatedTextContainer>
                <img src={passengerApp} alt="Passenger App" style={{ width: '100%', maxHeight: 'min(600px,70vh)', borderRadius: 10 }} />
              </AnimatedTextContainer>
            </Col>
            <Col xs={12} sm={12} md={6} lg={6} className="d-flex align-items-center justify-content-center" style={{ padding: '2.5rem' }}>
              <AnimatedTextContainer>
                <div className="assistance-info">
                  <h1 style={{ fontWeight: 200, fontFamily: 'inter' }}>
                    Need to request assistance?
                  </h1>
                  <div className="mt-5 d-flex flex-column justify-content-center gap-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                    <div>
                      <h4>Make PRM assistance bookings globally</h4>
                      <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>
                        Plan ahead by scheduling assistance services at airports around the world.
                      </p>
                    </div>
                    <div>
                      <h4>Retrieve and manage your airline assistance requests</h4>
                      <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>
                        Access all your past and upcoming bookings in one easy-to-use dashboard.
                      </p>
                    </div>
                    <div>
                      <h4>Communicate directly with airport staff via Support Desk</h4>
                      <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>
                        Get real-time help or updates by messaging support teams instantly.
                      </p>
                    </div>
                    <div>
                      <h4>Add personalized notes to tailor your assistance</h4>
                      <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>
                        Share special requirements or preferences to ensure a smooth experience.
                      </p>
                    </div>
                    <div>
                      <h4>Pre-purchase travel essentials for convenient pickup</h4>
                      <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "'Inter', sans-serif" }}>
                        Buy mobility aids, comfort items, or travel accessories in advance for airport pickup.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 w-100 d-flex flex-column flex-lg-row gap-2">
                  {/* iOS Download Button */}
                  <button
                    style={{
                      flex: 1,
                      borderRadius: '50px',
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '10px 20px',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      cursor: 'pointer',
                    }}
                    onClick={() => window.open(iOSUrl, '_blank')}
                  >
                    <FontAwesomeIcon icon={faAppStoreIos} />
                    Download on iOS
                  </button>
                  {/* Android Download Button */}
                  <button
                    style={{
                      flex: 1,
                      borderRadius: '50px',
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '10px 20px',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      cursor: 'pointer',
                    }}
                    onClick={() => window.open(androidUrl, '_blank')}
                  >
                    <FontAwesomeIcon icon={faGooglePlay} />
                    Download on Android
                  </button>
                </div>
              </AnimatedTextContainer>
            </Col>
          </Row>
        </section>

        {/* FIXME: the height changes, fix it */}
        {/* our partners 
        <section className='full-height-section p-2 p-lg-5'>
          <Row className='' style={{ width: '100%', minHeight: '600px' }}>
            <AnimatedTextContainer>
              <Col xs={12} sm={12} style={{ padding: '2.5rem'}} >
                <h1 style={{ fontWeight: 200, fontFamily: 'inter' }}>Our Partners</h1>
                <p style={{ fontSize: 18, opacity: 0.6, fontFamily: "inter, sans-serif", }}>Our operations experience and our modern solutions are helping airports, airlines and passengers globally</p>
              </Col>
            </AnimatedTextContainer>
            <AnimatedTextContainer>
              <PartnerCarousel />
            </AnimatedTextContainer>
          </Row>
        </section>
        */}

        {/* footer */}
        <Footer />
      </div>
    </>

  );
}
export default Home;
